import React from 'react';
import { Box } from 'rebass';
import styled from 'styled-components';
import HeaderStep from './header-step';
import { Text, ReactSelectBase, Spacer } from '@plug/ui';
import { OnboardingFeatureProps } from '../types';

import isDesktop from '@plug/helpers/is-desktop';

interface Values {
  category: string;
  quantityReseller: number;
  goal: string;
}

const ReactSelectInline = styled(ReactSelectBase)`
  width: ${props => props.width};
  padding-bottom: 8px;
  display: inline-block;
`;

const category = [
  'Acessórios Automotivos',
  'Alimentos e Bebidas',
  'Arte e Antiguidades',
  'Artesanato',
  'Artigos promocionais',
  'Artigos Religiosos',
  'Bebês e Cia',
  'Bebidas Alcoólicas',
  'Blu-Ray, DVD, CD e VHS',
  'Brinquedos e Colecionáveis',
  'Casa e Decoração',
  'Construção e Ferramentas',
  'Cosméticos, Perfumaria e Cuidados Pessoais',
  'Eletrodomésticos',
  'Eletrônicos',
  'Equipamentos para Laboratório',
  'Esporte e Lazer',
  'Festas e Eventos',
  'Fitness e Suplementos',
  'Fotografia',
  'Games',
  'Gráfica',
  'Informática',
  'Ingressos',
  'Instrumentos Musicais',
  'Livros e Revistas',
  'Loja de departamentos',
  'Moda e Acessórios',
  'Móveis',
  'Papelaria e Escritório',
  'Pet Shop',
  'Presentes, Flores e Cestas',
  'Prestação de Serviço',
  'Relojoaria e Joalheria',
  'Saúde',
  'Sex Shop',
  'Telefonia e Celulares',
  'Viagens e Turismo',
  'Outro',
];

export const categoryOptions = category.map((item: any) => ({
  value: item,
  label: item,
}));

const quantityReseller = [100, 500, 1000];
export const quantityResellerOptions = quantityReseller.map((item: any) => ({
  value: item.toString(),
  label: item.toString(),
}));

const goal = ['Criar uma rede de revendedores', 'Ter mais uma opção de canal de vendas', 'Ambos'];
export const goalOptions = goal.map(item => ({
  value: item,
  label: item,
}));

const StepCustomize: React.FC<OnboardingFeatureProps> = props => {
  const { formik } = props;

  return (
    <Box>
      <HeaderStep
        title="Vamos personalizar ✏️"
        subtitle={
          <span>
            Conte-nos um pouco sobre{' '}
            {formik.formik.values.name === '' ? (
              'a organização'
            ) : (
              <span style={{ color: '#1C1637' }}>{formik.formik.values.name}</span>
            )}
            .
          </span>
        }
      />
      <>
        <Text as="span" fontSize={isDesktop ? '20px' : '14px'}>
          Somos do segmento
        </Text>{' '}
        {!isDesktop && <Spacer marginY="6px" />}
        <ReactSelectInline
          defaultInputValue={''}
          width="250px"
          placeholder="selecione o segmento"
          options={categoryOptions}
          onChange={(selectedOption: any): void => {
            formik.formik.setFieldValue('category', selectedOption.value);
          }}
          value={categoryOptions.find(
            (category: any) => category.value === formik.initialValues.category,
          )}
        />{' '}
        {!isDesktop && <Spacer marginY="6px" />}
        <Text as="span" fontSize={isDesktop ? '20px' : '14px'}>
          e quero plugar até
        </Text>{' '}
        {!isDesktop && <Spacer marginY="12px" />}
        <ReactSelectInline
          defaultInputValue={''}
          width="90px"
          placeholder="0"
          options={quantityResellerOptions}
          onChange={(selectedOption: any): void => {
            formik.formik.setFieldValue('quantityReseller', selectedOption.value);
          }}
          value={quantityResellerOptions.find(
            (quantityReseller: any) =>
              quantityReseller.value === formik.initialValues.quantityReseller,
          )}
        />{' '}
        <Text as="span" fontSize={isDesktop ? '20px' : '14px'}>
          revendedores {!isDesktop && <Spacer marginY="6px" />}para{' '}
        </Text>
        {!isDesktop && <Spacer marginY="12px" />}
        <ReactSelectInline
          defaultInputValue={''}
          width="240px"
          placeholder="selectione um motivo"
          options={goalOptions}
          onChange={(selectedOption: any): void => {
            formik.formik.setFieldValue('goal', selectedOption.value);
          }}
          value={goalOptions.find((goal: any) => goal.value === formik.initialValues.goal)}
        />
      </>
    </Box>
  );
};

export default StepCustomize;
